import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Col } from 'antd';

import Styles from './SearchIcon.module.scss';
import SearchImage from 'images/magnifying-glass-new.png';
import Image from 'Pages/Home/Components/Atoms/Image';

const SearchIcon: React.FC = () => {
  return (
    <Col>
      <Image src={SearchImage} className={Styles['search-button-image']} />
    </Col>
  );
};

export default SearchIcon;
